module.exports = __webpack_public_path__ + "static/FAQMasthead-c5f8bdbbfdf6d866a68aff431c9e6444.png";